import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router";

import ShopContext from "../../store/shop-context";

import FoodItem from './FoodItem/FoodItem';
import Card from '../UI/Card';
import classes from './styles/FoodList.module.css';
import { getItems } from "../../api/main";

const FoodList = () => {
  let navigate = useNavigate();
  const shopContext = useContext(ShopContext);
  const [items, setItems] = useState([]);

  const get = async () => {
    const data = await getItems();
    setItems(data);
  }

  useEffect(() => {
    get();
  }, []);

  const foodList = items.map((food) => {
    const { id, name, description, price } = food;
    return (
      <FoodItem
        key={id}
        id={id}
        name={name}
        description={description}
        price={price}
      />
    );
  });
  
  return (
    <section className={classes.food}>
      <Card>
        <FoodItem
          id={1}
          promoId={1}
          name={"2x1 en 1/4Kg"}
          description={""}
          price={4000}
          showQtySelector={true}
          defaultQty={1}
        />
        {foodList}
      </Card>
    </section>
  );
};

export default FoodList;
